"use client";

import * as React from "react";

// @components
import {
  Button,
  DropdownMenu,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuContent,
} from "@/components";

// @icons
import { CheckIcon, ChevronDownIcon } from "@heroicons/react/24/outline";

// @hooks
import { useVariation } from "../store";

export function Variation() {
  const variation = useVariation((state: any) => state.variation);
  const setToPHEX = useVariation((state: any) => state.setToPHEX);
  const setToEHEX = useVariation((state: any) => state.setToEHEX);
  const setToBoth = useVariation((state: any) => state.setToBoth);

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger
        asChild
        aria-label="Variation Selector"
        className="group outline-none focus-visible:outline-none"
      >
        <Button
          variant="simple"
          contentClassName="!px-4 !py-3 flex items-center gap-3"
        >
          {variation}
          <ChevronDownIcon className="h-4 w-4 stroke-2 transition-transform duration-200 group-data-[state=open]:rotate-180" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="min-w-40">
        <DropdownMenuItem onClick={setToEHEX}>
          <span className="mr-4">EHEX</span>
          {variation === "EHEX" && (
            <CheckIcon className="ml-auto h-4 w-4 stroke-2" />
          )}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={setToPHEX}>
          <span className="mr-4">PHEX</span>
          {variation === "PHEX" && (
            <CheckIcon className="ml-auto h-4 w-4 stroke-2" />
          )}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={setToBoth}>
          <span className="mr-4">EHEX & PHEX</span>
          {variation === "EHEX & PHEX" && (
            <CheckIcon className="ml-auto h-4 w-4 stroke-2" />
          )}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
